import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { getAllReports, getFilteredReports } from "../../http";

const InternReportsView = () => {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({
    submittedDate: "",
    internName: "",
    teamId: "",
  });

  useEffect(() => {
    fetchAllReports();
  }, []);

  const fetchAllReports = async () => {
    try {
      setLoading(true);
      const response = await getAllReports();
      console.log("Admin reports response:", response); // Debug log
      if (response && Array.isArray(response.data)) {
        setReports(response.data);
      } else if (response && Array.isArray(response)) {
        setReports(response);
      } else {
        console.error("Unexpected response format:", response);
        setReports([]);
      }
    } catch (error) {
      console.error("Error fetching reports:", error);
      toast.error("Failed to fetch reports");
    } finally {
      setLoading(false);
    }
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const applyFilters = async () => {
    try {
      setLoading(true);
      // Only include non-empty filters
      const nonEmptyFilters = Object.fromEntries(
        Object.entries(filters).filter(([_, value]) => value !== "")
      );

      const response = await getFilteredReports(nonEmptyFilters);
      if (response && Array.isArray(response.data)) {
        setReports(response.data);
      } else if (response && Array.isArray(response)) {
        setReports(response);
      }
    } catch (error) {
      console.error("Error applying filters:", error);
      toast.error("Failed to apply filters");
    } finally {
      setLoading(false);
    }
  };

  const resetFilters = () => {
    setFilters({
      submittedDate: "",
      internName: "",
      teamId: "",
    });
    fetchAllReports();
  };

  return (
    <div className="main-content">
      <section className="section">
        <div className="card">
          <div className="card-header d-flex justify-content-between align-items-center">
            <h4>All Intern Reports</h4>
            <button className="btn btn-secondary" onClick={resetFilters}>
              Reset Filters
            </button>
          </div>
          <div className="card-body">
            {/* Updated Filters */}
            <div className="row mb-4">
              <div className="col-md-3">
                <label className="form-label">Submitted Date</label>
                <input
                  type="date"
                  className="form-control"
                  name="submittedDate"
                  value={filters.submittedDate}
                  onChange={handleFilterChange}
                />
              </div>
              <div className="col-md-3">
                <label className="form-label">Intern Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="internName"
                  value={filters.internName}
                  onChange={handleFilterChange}
                  placeholder="Search by name"
                />
              </div>
              <div className="col-md-3">
                <label className="form-label">Team ID</label>
                <input
                  type="text"
                  className="form-control"
                  name="teamId"
                  value={filters.teamId}
                  onChange={handleFilterChange}
                  placeholder="Team ID"
                />
              </div>
              <div className="col-md-3 d-flex align-items-end">
                <button
                  className="btn btn-primary"
                  onClick={applyFilters}
                  disabled={loading}>
                  Filter
                </button>
              </div>
            </div>

            {/* Reports Table */}
            {loading ? (
              <div className="text-center">Loading...</div>
            ) : reports.length > 0 ? (
              <div className="table-responsive">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>Date</th>
                      <th>Intern Name</th>
                      <th>Team ID</th>
                      <th>Tasks</th>
                      <th>Status</th>
                      <th>Remarks</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reports.map((report, index) => (
                      <tr key={index}>
                        <td>{new Date(report.date).toLocaleDateString()}</td>
                        <td>{report.employeeId.name}</td>
                        <td>{report.teamId}</td>
                        <td>
                          <ul className="list-unstyled mb-0">
                            {report.reports.map((r, i) => (
                              <li key={i} className="mb-1">
                                {r.task}
                              </li>
                            ))}
                          </ul>
                        </td>
                        <td>
                          <ul className="list-unstyled mb-0">
                            {report.reports.map((r, i) => (
                              <li key={i} className="mb-1">
                                <span
                                  className={`badge bg-${getStatusColor(
                                    r.status
                                  )}`}>
                                  {r.status}
                                </span>
                              </li>
                            ))}
                          </ul>
                        </td>
                        <td>
                          <ul className="list-unstyled mb-0">
                            {report.reports.map((r, i) => (
                              <li key={i} className="mb-1">
                                {r.remark}
                              </li>
                            ))}
                          </ul>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center">No reports found</div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
};

// Helper function to get status color
const getStatusColor = (status) => {
  switch (status) {
    case "Completed":
      return "success";
    case "In Progress":
      return "info";
    case "Pending":
      return "warning";
    case "Blocked":
      return "danger";
    default:
      return "secondary";
  }
};

export default InternReportsView;
